module.exports = function() {
    var touchDevice = !!(("ontouchstart" in window) || window.DocumentTouch && document instanceof DocumentTouch || navigator.msMaxTouchPoints);

    this.isTouch = function() {
        return touchDevice;
    };

    return $.Deferred().resolve().promise();
};



//////////////////
// WEBPACK FOOTER
// ./client_config/BrowserUserInteractionDetector.js
// module id = 124
// module chunks = 0